import { z } from 'zod'
import { type RiskReductionMeasureType } from '@/shared/hooks/api/machineryDirectiveCompliance'

export type RiskReductionMeasureFormData = {
  name: string
  type: RiskReductionMeasureType
  description: string
  dependsOnControlSystem: boolean
  safetyFunctionId: string | null
  ehsrClauseIds: string[]
}

export const defaultRiskReductionMeasureFormData: RiskReductionMeasureFormData = {
  name: '',
  type: 'ISD',
  description: '',
  dependsOnControlSystem: false,
  safetyFunctionId: null,
  ehsrClauseIds: [],
}

const riskReductionMeasureTypeSchema = z.enum([
  'ISD',
  'SCP',
  'PPE',
  'OI',
])

export const riskReductionMeasureFormSchema = z.object({
  name: z.string().trim().min(1),
  type: riskReductionMeasureTypeSchema,
  description: z.string().trim().min(1),
  dependsOnControlSystem: z.boolean(),
})

export function validateRiskReductionMeasureForm(data: RiskReductionMeasureFormData) {
  return riskReductionMeasureFormSchema.safeParse(data)
}
